import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-progress" }
const _hoisted_2 = { class: "header-progress--bar" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderProgressBar',
  props: {
    from: { default: 0 },
    to: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { from: number, to: number };



const toPercent = computed(() => {
  return `${props.to}%`;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "header-progress--bar-line",
        style: _normalizeStyle({ width: _unref(toPercent) })
      }, null, 4)
    ])
  ]))
}
}

})